import React from 'react'
import KakaoModifyComponent from '../../components/member/KakaoModifyComponent'


const KakaoModifyPage = () => {
  return (
    <>    
    <div className='mb-5'>수정 페이지</div>
    <KakaoModifyComponent />
    </>

  )
}

export default KakaoModifyPage